import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fl-sidebar-footer',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFooterComponent {}
